export enum PaginationParams {
  Page = 'page',
  PageSize = 'pageSize',
  Filter = 'filter',
  SortBy = 'sortBy',
}
